import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { useStyles, useStylesSvgIcon } from './styles';

const CustomCheckbox = ({ isChecked, setChecked, isDisabled }) => {
  const classes = useStyles();
  const classesSvgIcon = useStylesSvgIcon();

  const handleCheckboxChange = () => setChecked(!isChecked);

  const defineCheckboxStyle = ({ checked, disabled }) => {
    if (checked) {
      return {
        borderColor: '#FF9B07',
      };
    }

    if (disabled) {
      return {
        borderColor: '#414a59',
        backgroundColor: '#2d384b',
      };
    }

    return {
      borderColor: '#43566C',
    };
  };

  const checkBoxStyle = defineCheckboxStyle({
    checked: isChecked,
    disabled: isDisabled,
  });

  return (
    <div className={classes.checkboxWrapper}>
      <input
        type="checkbox"
        onChange={handleCheckboxChange}
        className={classes.hiddenInputCheckbox}
        disabled={isDisabled}
      />
      <div className={classes.substituteStyledCheckbox} style={checkBoxStyle}>
        {isChecked ? (
          <div className={classes.checkMarkWrapper}>
            <CheckIcon classes={classesSvgIcon} />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CustomCheckbox;
